
import ChatInput from 'components/chat-input'
import $chats from 'stores/chats'
import $profile from 'stores/profile'
import {computed} from 'vue'

export default {
  components: {ChatInput},
  provide() {
    return {
      di_chat_mode: computed({
        get: () => this.mode,
        set: mode => this.mode = mode
      })
    }
  },
  data() {
    return {
      input_text: '',
      mode: 'deep'
    }
  },
  async beforeMount() {
    if (!this.$route.query.chat_query) return

    const params = JSON.parse(this.$route.query.chat_query)
    const chat = await $chats.newChat(params, $profile.chat_type)
    this.$global.goToChat(chat.id)
  },
  mounted() {
    if (this.$responsive.mobile) return
    this.$refs.input.focus()
  },
  methods: {
    async onChat(query) {
      const chat = await $chats.newChat({...query, mode: this.mode}, $profile.chat_type)
      this.$global.goToChat(chat.id)
    }
  }
}
